import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom';
function HomeThreePoint({data}) {
  if (!data) {
    return null; // Correct return for better handling
  }
  
  return (
    <> 
    <section className="home-three-point">
      <Container>
        <Row>
          
          {data.cards.map((card, index) => (
            <Col key={"kl"+index} sm="12" md="4" className='mb-4 mb-md-0'>
              <Link to={card.link || '/'} title={card.title} className="home-three-point-box">
                <img className="home-resources-box-img" src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${card.image}`} alt={card.title || 'Image'} />
                <h2>{card.title}</h2>
                <p>{card.subtitle}</p>
              </Link>
            </Col>
          ))}

        </Row>        
      </Container>
    </section>
    </>
  )
}
export default HomeThreePoint